import * as React from 'react';
import { SupportTopic } from './Models/SupportTopic';
import { Helper } from './Utilities/Helper';

interface ITopTopicsViewProps {
  topTopicsList: [SupportTopic, string][];
  topTopicSelection: (topTopicPair: [SupportTopic, string]) => void;
}

interface ITopTopicsViewState {
  windowWidth: number;
}

export default class TopTopicsView extends React.Component<ITopTopicsViewProps, ITopTopicsViewState> {
  private lexicographicOrderList: [SupportTopic, string][];
  // order such that a two column rendered view is column major sorted
  private alternatingLexicographicOrderList: [SupportTopic, string][];

  constructor(props: ITopTopicsViewProps) {
    super(props);
    this.state = { windowWidth: window.innerWidth };
    this.lexicographicOrderList = this.props.topTopicsList.sort(Helper.topTopicDisplaySortHelper);
    this.alternatingLexicographicOrderList = this.alternatingLexicographicSort(
      this.props.topTopicsList.sort(Helper.topTopicDisplaySortHelper)
    );
  }

  private alternatingLexicographicSort = function (
    sortedTopicsList: [SupportTopic, string][]
  ): [SupportTopic, string][] {
    if (sortedTopicsList.length == 0) {
      return sortedTopicsList;
    }
    let alternatingSort = [];
    let end = sortedTopicsList.length;
    let middle = Math.floor((sortedTopicsList.length - 1) / 2) + 1;
    let i = 0,
      j = middle;
    while (i < middle || j < end) {
      if (i < middle) {
        alternatingSort.push(sortedTopicsList[i]);
        i = i + 1;
      }
      if (j < end) {
        alternatingSort.push(sortedTopicsList[j]);
        j = j + 1;
      }
    }

    return alternatingSort;
  };

  private windowResized = () => {
    this.setState({ windowWidth: window.innerWidth });
  };

  componentDidMount() {
    window.addEventListener('resize', this.windowResized);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.windowResized);
  }

  public render() {
    // 768 pixels of window width is the point at which the xs style is invoked over the md style
    let ListOrder = this.alternatingLexicographicOrderList;
    if (this.state.windowWidth < 768) {
      ListOrder = this.lexicographicOrderList;
    }
    return (
      <div className="row">
        {ListOrder.map((supportTopicPair: [SupportTopic, string]) => (
          <div className="col-xs-24 col-md-12 noPadding">
            <button
              data-toggle="tab"
              style={{
                paddingTop: '0px',
                paddingLeft: '24px',
                paddingRight: '24px',
                textDecoration: 'none',
                outline: 0,
              }}
              title={Helper.getTopTopicLabel(supportTopicPair[0])}
              className="generalLink btn-link topTopicTruncate"
              onClick={e => this.props.topTopicSelection(supportTopicPair)}
            >
              <span>{Helper.getTopTopicLabel(supportTopicPair[0])}</span>
              <span className="win-icon win-icon-topTopic-ChevronRight"></span>
            </button>
          </div>
        ))}
      </div>
    );
  }
}
